import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function LastVisitedUrlTracker(): JSX.Element {
  const location = useLocation();

  useEffect(() => {
    const currentUrl = location.pathname + location.search;
    const isOAuthCallback = currentUrl.startsWith('/dataops-oauth-callback');
    const isPlatformAuthRoot = currentUrl === '/platform-auth';
    if (!isOAuthCallback && !isPlatformAuthRoot) {
      localStorage.setItem('lastVisitedUrl', currentUrl);
    }
  }, [location]);

  return <></>;
}
